export  const profileDictionary = {
editProfile:{fa:"ویرایش پروفایل" , en:"Edit profile"},
myPhoecoins:{fa:"فیکوین های من" , en:"my Phoecoins"},
awardHistory:{fa:"تاریخچه جوایز" , en:"Awards history"},
purchase:{fa:"خرید" , en:"Purchase"},
discountCode:{fa:"کد تخفیف" , en:"Discount code"},
pinCharge:{fa:"رمز شارژ" , en:"Charge pin"},
expDate:{fa:"تاریخ انقضا" , en:"Expiration date"},
changeImage:{fa:"میتوانید تصویر پروفایل خود را تغییر دهید" , en:"change your profile avatar"},
successEdit:{fa:"پروفایل با موفقیت ویرایش شد",en:"Profile is edited successfully."}
}